export default __webpack_public_path__ + "static/media/P310 zu P311.cfed6164.mp3";